import React, { useCallback, useState } from "react"
import ObservationModal from "../../../../../components/ObservationModal"
import { ObsButton } from "./styles"
import { useCheckoutFunction } from "../../../../../hooks/useCheckoutFunctions";
import { checkoutActionTypes } from "../../../../../store/modules/checkout/types";
import { MdEdit } from "react-icons/md";

interface IProductObservation {
    productId?: string,
    inputValue: string;
    ProductObservation?: string;
}

export function ProductObservation({inputValue, productId, ProductObservation}: IProductObservation) {
    const [observation, setObservation] = useState(ProductObservation || '');
    const { handleCheckoutActions } = useCheckoutFunction();
    const [isObsModalOpen, setIsObsModalOpen] = useState(false);

    const updateCustomerCard = useCallback(
        async () => {
            handleCheckoutActions(
                checkoutActionTypes.UPDATE_PLU_QTY_CHECKOUT,
                productId || '',
                inputValue.replace(',', '.'),
                undefined,
                undefined,
                observation
            );
        },
        [observation, handleCheckoutActions, inputValue, productId],
    );
    return (
        <>
            {/* Botão + Obs */}
            <ObsButton
             id="button-action-observation"
             onClick={() => setIsObsModalOpen(true)}><MdEdit color="var(--btn-finish)" size={28} /></ObsButton>

            {/* Modal de Observações */}
            <ObservationModal
                isOpen={isObsModalOpen}
                onClose={() => setIsObsModalOpen(false)}
                observation={observation}
                onSave={() => updateCustomerCard()}
                setObservation={setObservation}
            />
        </>
    )
}